// extracted by mini-css-extract-plugin
module.exports = {"link":"styles-module__link___3hFG9","link48":"styles-module__link48___1itag","image":"styles-module__image___1tspr"};